import { DownloadOutlined } from '@ant-design/icons';
import { LC_FULL_PAGE_DOWNLOAD } from '@mm/api-routes';
import { Tooltip } from 'antd';
import React from 'react';
import styles from './PdfReportButton.module.css';

export const PdfReportButton = ({
  isWhiteLabel,
  version,
}: {
  isWhiteLabel?: boolean;
  version: string;
}) => {
  const splitPageUrl = window.location.href.split('/');
  // Note: currently we not always show the version, sometimes it is hidden in stead instead of being part of URL
  const pageUrlWithoutVersion =
    splitPageUrl.length > 5
      ? splitPageUrl.slice(0, -1).join('/')
      : window.location.href;

  const pageUrlForPdf = LC_FULL_PAGE_DOWNLOAD(
    `${pageUrlWithoutVersion}/${version.toLowerCase()}?whitelabel=true`,
  );

  return (
    <section className={styles.pdfDownload}>
      {!isWhiteLabel && (
        <Tooltip title="Please wait for about 10 seconds after clicking for the report to be generated">
          <div className={styles.pdfDownloadButton}>
            <a
              href={pageUrlForPdf}
              download="full_page_pdf.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <DownloadOutlined size={20} /> Download as PDF
            </a>
          </div>
        </Tooltip>
      )}
    </section>
  );
};
